import React from 'react'

import classes from "./ControlsBarButton.module.css";

const ControlsBarButton = (props) => {

    const handleActiveButtonOnClick = (buttonText) => {
        props.onClick(buttonText)
        props.setActiveButton(buttonText)
    }

    return (
        <button
            type={props.type || "button"}
            className={`${classes["button-container"]} ${
            props.activeButton === props.id ? classes.active : classes.inactive
            }`}
            onClick={() => handleActiveButtonOnClick(props.id)}
            disabled={props.disabled}
            onMouseEnter={props.handleMouseEnter}
            onMouseLeave={props.handleMouseLeave}
        >
            <img
            className={`${classes.img} ${
                props.activeButton === props.id ? classes.activeImg : ""
            }`}
            src={props.imagePath}
            alt=""
            />
            {props.title || ""}
        </button>
    );

}

export default ControlsBarButton